var yy_request = require('../js/yunyin_request')
var po = require('../js/public_object.js')

module.exports = {
  data: function() {
    return {
      schoolId: '-1',
      schoolList: [{value:"-1",text:"所有学校"}],
      printersPerPage: 10,
      printerList: [],
      displayedPage: 1,
      moreData: true,
    }
  },

  compiled: function() {
    var info = po.schoolsinfo
    var options = []
    for(var key in info) {
      options.push({
        value: info[key].id,
        text: info[key].name,
      })
    }
    this.schoolList = this.schoolList.concat(options)
    if(po.islogin) {
      this.schoolId = po.userinfo.sch_id
    }
    loadData(this)
  },

  methods: {
    changeSchool: function(e) {
      this.displayedPage = 1
      loadData(this)
    },

    loadMore: function(e) {
      this.displayedPage += 1
      loadData(this)
    }
  },

  components: {
    'custom-select': require('../controls/custom-select.vue'),
  },
}

function loadData(vuemodel) {
  var ajax_data = {
    page: vuemodel.displayedPage
  }

  if(vuemodel.schoolId!='-1') {
    ajax_data.sch_id = vuemodel.schoolId
  }

  yy_request.rest_api({
    method: 'get',
    api: 'printers/',
    data: ajax_data, 
    opSuccess: function(info) {
      var printerdata = info
      if(printerdata.length==vuemodel.printersPerPage) {
        vuemodel.moreData = true
      } else {
        vuemodel.moreData = false
      }
      for(var i in printerdata) {
        printerdata[i].sch_name = po.schoolsinfo[printerdata[i].sch_id].name
      }

      if(vuemodel.displayedPage==1) {
        vuemodel.printerList = printerdata
      } else {
        vuemodel.printerList = vuemodel.printerList.concat(printerdata)       
      }
    },
  })
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/printer-view.vue
// module id = 156
// module chunks = 0